/* Use the theme's existing lazy slider, without measuring offscreen/hidden cards. */
class ODSProductCarousel extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.initialized = false;
    this.pending = false;
    // Kalles destroys its instance on removal. A moved, previously used element
    // needs a fresh native element, not a second InitLazy on its destroyed API.
    if (this.usedSlider && this.contains(this.usedSlider)) this.usedSlider.replaceWith(this.usedSlider.cloneNode(true));
    this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) this.initialize();
    }, { rootMargin: '300px 0px' });
    this.observer.observe(this);
    const { signal } = this.controller;
    this.addEventListener('pointerenter', () => this.initialize(), { signal });
    this.addEventListener('focusin', () => this.initialize(), { signal });
    this.addEventListener('pointerdown', () => this.initialize(), { signal, capture: true });
  }

  async initialize() {
    if (this.initialized || this.pending || !this.isConnected) return;
    const slider = this.querySelector('hdt-slider-lazy');
    if (!slider || !slider.getClientRects().length || getComputedStyle(slider).visibility === 'hidden') return;
    this.pending = true;
    const controller = this.controller;
    await customElements.whenDefined('hdt-slider-lazy');
    if (controller.signal.aborted || !this.isConnected) return;
    slider.InitLazy();
    this.usedSlider = slider;
    this.initialized = true;
    this.pending = false;
    this.dataset.carouselState = 'ready';
    this.observer.disconnect();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    delete this.dataset.carouselState;
  }
}

if (!customElements.get('ods-product-carousel')) customElements.define('ods-product-carousel', ODSProductCarousel);
